import React from "react";
import { SelectionToggleProps } from "./interface";
import "./SelectionToggle.scss";

const Index = ({
  options,
  labelWidth = "126px"
}: SelectionToggleProps) => {

  const getLabelWidth = (value: number): string | undefined => {
    if (value === 0) return "130px";
    if (value === 1 && typeof labelWidth === "string") return labelWidth;
    return undefined;
  };
  return (
    <div className="d-flex gap-1">
      {options.map(({ label, selected, onClick, id }, index) => (
        <div
          key={id}
          className={`form-check contactLensContainer form-check-inline mb-1 w-100 ${selected ? "fw-600" : "fw-400 text-muted"}`}
        >
          <label
            className="form-check-label w-100"
            htmlFor={id}
            style={{ cursor: "pointer", minWidth:getLabelWidth(index) }}
            onClick={onClick}
          >
            <input
              className="form-check-input"
              type="radio"
              name="contactLensStatus"
              id={id}
              checked={selected}
              readOnly
            />
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default Index;
